var map = {
	"./common/en.json": "78fo",
	"./common/zh-cn.json": "1VKD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qZHM";


//////////////////
// WEBPACK FOOTER
// ./src/lang \.json$
// module id = qZHM
// module chunks = 65